import { useEffect, useState } from "react";

import Hero from "@/components/Hero";
import ServicesGrid from "@/components/ServicesGrid";
import WhyUs from "@/components/WhyUs";
import ProjectsStrip from "@/components/ProjectsStrip";
import Testimonials from "@/components/Testimonials";
import QuoteCTA from "@/components/QuoteCTA";
import QuoteFormModal from "@/components/QuoteFormModal";
import FeaturedProducts from "@/components/FeaturedProducts";
import { endpoints } from "@/lib/api";
import { useSettings } from "@/lib/useSettings";

export default function Home() {
  const [services, setServices] = useState([]);
  const [projects, setProjects] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const { settings } = useSettings();

  useEffect(() => {
    endpoints.services().then(setServices).catch(() => {});
    endpoints.projects().then(setProjects).catch(() => {});
    endpoints.testimonials().then(setTestimonials).catch(() => {});
  }, []);

  return (
    <div data-testid="page-home">
      <Hero onOpenQuote={() => setQuoteOpen(true)} />
      <ServicesGrid services={services} />
      <FeaturedProducts />
      <WhyUs />
      <ProjectsStrip projects={projects.slice(0, 6)} />
      <Testimonials items={testimonials} />
      <QuoteCTA onOpenQuote={() => setQuoteOpen(true)} phone={settings?.phone} />
      <QuoteFormModal open={quoteOpen} onOpenChange={setQuoteOpen} />
    </div>
  );
}
